import React from 'react';
import EUNIMG from '../../assets/images/platform/EUNIMG.png'
import FCLIMG from '../../assets/images/platform/FCLIMG.png'
import CRIMG from '../../assets/images/platform/CRIMG.png'
import RTOIMG from '../../assets/images/platform/RTOIMG.png'

function SelfServePlatformSec() {
    return (
        <>
            <div class="InnerBSep"></div>
            <section className='SSPSec bg-white'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-lg-6'>
                            <div class="text-left">
                                <h2 class="display-5 fw-bold primary-title mb-4 otherpageTitle">Easy-to-Use Navigation</h2>
                            </div>

                            <p>PI's intuitive interface simplifies campaign planning, launching, and tracking. Programmatic India platform's task-based apps allow even novice users to plan and run campaigns, see detailed reports, and optimize in real-time.</p>
                            <ul className="">
                                <li className="aK6P7">
                                    
                                    <p>
                                        Fast, intuitive UI for easy campaign management
                                    </p>
                                </li>
                                <li className="aK6P7">
                                    
                                    <p>
                                    Task-based apps for effortless navigation
                                    </p>
                                </li>
                                <li className="aK6P7">
                                    
                                    <p>
                                        Real-time reports and analytics
                                    </p>
                                </li>
                                <li className="aK6P7">
                                    
                                    <p>
                                        Advanced optimization for better results
                                    </p>
                                </li>
                                <li className="aK6P7">
                                    
                                    <p>
                                        Streamlined creative asset management
                                    </p>
                                </li>
                            </ul>
                        </div>
                        <div className='col-lg-6'>
                            <div className=''>
                                <img src={EUNIMG} alt='' width="100%" />
                            </div>
                        </div>
                    </div>
                    <div className="gnagt">
                        <hr className="" />
                    </div>

                    <div className='row divReverse'>
                        <div className='col-lg-6'>
                            <div className=''>
                                <img src={FCLIMG} alt='' width="100%"  />
                            </div>
                        </div>
                        <div className='col-lg-6'>
                            <div className='discription'>
                                <div class="text-left">
                                    <h2 class="display-5 fw-bold primary-title mb-4 otherpageTitle">Fast Campaign Launch</h2>
                                </div>
                                <p>Launch a campaign effortlessly in under 30 minutes with our user-friendly platform, dedicated AdOps team, and efficient planning and support.</p>
                                <ul className="">
                                <li className="aK6P7">
                                    <p>
                                    Easy planning: Streamlined campaign planning
                                    </p>
                                </li>
                                <li className="aK6P7"> 
                                    <p>
                                    Supportive team: Always-available support
                                    </p>
                                </li>
                                <li className="aK6P7"> 
                                    <p>
                                    Fast and intuitive platform: User-friendly interface
                                    </p>
                                </li>
                                <li className="aK6P7">   
                                    <p>
                                    Quick approval: Streamlined approval process
                                    </p>
                                </li>
                                <li className="aK6P7">
                                    <p>
                                    Quick campaign launch time - Launch in less than 30 minutes.
                                    </p>
                                </li>
                            </ul>
                            </div>
                        </div>

                    </div>

                    <div className="gnagt">
                        <hr className="" />
                    </div>

                    <div className='row'>

                        <div className='col-lg-6'>
                            <div className='discription'>
                                <div class="text-left">
                                    <h2 class="display-5 fw-bold primary-title mb-4 otherpageTitle">Consolidated Reporting</h2>
                                </div>
                                <p>Easily track campaign performance across devices and mediums with consolidated reporting. Optimize in real-time to get the best performance for your ad spend.</p>
                                <ul className="">
                                <li className="aK6P7">
                                    <p>
                                    Cross-device tracking: Track performance across devices
                                    </p>
                                </li>
                                <li className="aK6P7"> 
                                    <p>
                                    Consolidated reporting: Easy-to-read campaign dashboard
                                    </p>
                                </li>
                                <li className="aK6P7"> 
                                    <p>
                                    Actionable insights: Data-driven decision-making
                                    </p>
                                </li>
                                <li className="aK6P7">   
                                    <p>
                                    Customizable reporting: Flexible reporting options
                                    </p>
                                </li>
                                
                            </ul>
                            </div>
                        </div>
                        <div className='col-lg-6'>
                            <div className=''>
                                <img src={CRIMG} alt='' width="100%"  />
                            </div>
                        </div>

                    </div>


                </div>
            </section>

            <section className='SSPSec gradientGrayBg'>
                <div className='container'>
                    <div className='row divReverse'>
                        <div className='col-lg-6'>
                            <div className='SSPImg'>
                                <img src={RTOIMG} alt='' width="100%" height="" />
                            </div>
                        </div>
                        <div className='col-lg-6'>
                            <div className='discription'>
                                <div class="text-left">
                                    <h2 class="display-5 fw-bold primary-title mb-4 otherpageTitle">Real-time Optimization</h2>
                                </div>

                                <p>Our AI-powered ad servers optimize every bid in real-time using advanced machine learning, ensuring that you reach your desired audience with the right message at a fair price.</p>
                                <ul className="">
                                <li className="aK6P7">
                                    <p>
                                    AI-powered ad servers: Optimized bidding & bid Shading
                                    </p>
                                </li>
                                <li className="aK6P7"> 
                                    <p>
                                    Real-time optimization: Multi-factor optimization
                                    </p>
                                </li>
                                <li className="aK6P7"> 
                                    <p>
                                    Increased ROI: Improved return on investment
                                    </p>
                                </li>
                                <li className="aK6P7">   
                                    <p>
                                    Continuous improvement: Learning and optimizing continuously
                                    </p>
                                </li>
                                <li className="aK6P7">   
                                    <p>
                                    Proactive monitoring: Monitoring for smooth performance
                                    </p>
                                </li>
                                
                            </ul>
                            </div>
                        </div>

                    </div>

                    <div className="gnagt">
                        <hr className="" />
                    </div>

                    <div className='row'>
                        
                        <div className='col-lg-6'>
                            <div className='discription'>
                                <div class="text-left">
                                    <h2 class="display-5 fw-bold primary-title mb-4 otherpageTitle">24X7 AdOps Support</h2>
                                </div>

                                <p>Get expert advice and support from our team of programmatic experts, whether you use our self-serve platform or managed services, to ensure your campaign goals are met.</p>
                                <ul className="">
                                <li className="aK6P7">
                                    <p>
                                    Personalized guidance for campaign goals
                                    </p>
                                </li>
                                <li className="aK6P7"> 
                                    <p>
                                    Optimize targeting, messaging, and creative
                                    </p>
                                </li>
                                <li className="aK6P7"> 
                                    <p>
                                    Ongoing support for campaign success
                                    </p>
                                </li>
                                <li className="aK6P7">   
                                    <p>
                                    Industry insights for better campaigns
                                    </p>
                                </li>
                                <li className="aK6P7">   
                                    <p>
                                    Monitor and analyze campaign performance
                                    </p>
                                </li>
                                
                            </ul>
                            </div>
                        </div>

                        <div className='col-lg-6'>
                            <div className='SSPImg'>
                                <img src={RTOIMG} alt='' width="100%" height="" />
                            </div>
                        </div>

                    </div>

                </div>
            </section>
        </>
    );
}

export default SelfServePlatformSec;
